module.exports = __webpack_public_path__ + "static/media/orujo.c94bbe6e.jpg";